
import { Clock, CreditCard, LineChart, PieChart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function FeatureHighlights() {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 bg-gradient-to-b from-white to-muted/10">
      <div className="container max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Built For Any Workflow</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Hour Tracker provides workflow-optimized tools that adapt to any business model, without any complexity.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-shrink-0 p-4 bg-primary/10 rounded-lg h-fit">
              <Clock className="h-8 w-8 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Flexible Time Tracking</h3>
              <p className="text-muted-foreground mb-4">
                Start and stop timers with one click or add manual entries. Organize by projects and clients - works with any workflow.
              </p>
              <Button variant="outline" onClick={() => navigate("/learn-more#time-tracking")}>
                Learn More
              </Button>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-shrink-0 p-4 bg-primary/10 rounded-lg h-fit">
              <CreditCard className="h-8 w-8 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Professional Invoices</h3>
              <p className="text-muted-foreground mb-4">
                Generate detailed invoices from your time entries with just one click. Add your logo and customize for your workflow.
              </p>
              <Button variant="outline" onClick={() => navigate("/learn-more#invoices")}>
                Learn More
              </Button>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-shrink-0 p-4 bg-primary/10 rounded-lg h-fit">
              <PieChart className="h-8 w-8 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Workflow Insights</h3>
              <p className="text-muted-foreground mb-4">
                Track time spent across all your projects. Set hourly rates and budgets. Monitor your most profitable workflow patterns.
              </p>
              <Button variant="outline" onClick={() => navigate("/learn-more#projects")}>
                Learn More
              </Button>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-shrink-0 p-4 bg-primary/10 rounded-lg h-fit">
              <LineChart className="h-8 w-8 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Business Analytics</h3>
              <p className="text-muted-foreground mb-4">
                Visualize your productivity with detailed reports. Track earnings trends and optimize your workflow for maximum efficiency.
              </p>
              <Button variant="outline" onClick={() => navigate("/learn-more#analytics")}>
                Learn More
              </Button>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <Button size="lg" onClick={() => navigate("/auth?mode=signup")}>
            Start Using Hour Tracker
          </Button>
        </div>
      </div>
    </section>
  );
}
